import { ThunkResult } from 'store/types';
import { OpenDrawerParams } from 'types/drawers';
import { createAction } from 'typesafe-actions';
import { DrawersActionTypes } from './types';

export const openDrawerAction = createAction(DrawersActionTypes.OPEN_DRAWER)<OpenDrawerParams>();
export const closeDrawer = createAction(DrawersActionTypes.CLOSE_DRAWER)();
export const updateDrawerWidth = createAction(DrawersActionTypes.UPDATE_DRAWER_WIDTH)<number>();

export const openDrawer = (data: OpenDrawerParams): ThunkResult =>
  async function openDrawerThunk(dispatch) {
    dispatch(openDrawerAction(data));
  };
